<template>
    <div>
        <div class="task" v-if="page === 'task'">
            <p-header :title="title"/>
            <search-address
                    class="search"
                    ref="address"
                    :isFocus="isFocus"
                    :value="fullAddress"
                    :err="roadErr"
                    @onSelected="selectedPlace"
                    @onFocus="searching = true"
                    @onBlur="searching = false"/>
            <div class="input-data" v-show="! searching">
                <div class="item">
                    <span>棟/ 樓/ 層/ 室/</span>
                    <input type="text" v-model="additional" placeholder="A棟 B1 在超市旁邊">
                </div>
                <div class="item">
                    <span>公司/ 大樓名稱</span>
                    <input type="text" v-model="alias" placeholder="XX大樓">
                </div>
                <div class="item note" :class="{'err': err}" @click="showNote">
                    <span>任務內容</span>
                    <a-textarea v-model="note" placeholder="這個地點要做什麼事情呢？"></a-textarea>
                    <div v-show="err">
                        <div class="line"></div>
                        <span class="err-msg">
                        {{ err }}
                    </span>
                    </div>
                    <limit-size/>
                </div>
                <div class="item">
                    <span>聯絡人姓名</span>
                    <div class="checkbox" v-show="user.name">
                        <input type="checkbox" id="checkbox" v-model="isPrincipal" @change="clickPrincipal" ref="principal" hidden>
                        <label for="checkbox">
                            <img v-show="isPrincipal" src="@/assets/img/check.svg">
                            <img v-show="!isPrincipal" src="@/assets/img/check-none.svg">
                            同委託人
                        </label>
                    </div>
                    <input type="text" v-model="name" placeholder="這個地點聯絡人是誰？" @change="unclickPrincipal">
                </div>
                <div class="item">
                    <span>聯絡人電話</span>
                    <input type="text" v-model="phone" placeholder="聯絡電話是多少？" @change="unclickPrincipal">
                </div>
            </div>
            <task-input v-model="expectedPrice" v-show="! searching && expectedPrice.length"/>
            <photo-uploader v-model="photos" v-show="! searching && photos.length"/>
            <div class="detail" v-show="! searching">
                <div class="item">
                    <div class="span">儲存為常用地址</div>
                    <div class="input">
                        <p-switch v-model="isSave"/>
                    </div>
                </div>
                <div class="button" @click="send">
                    確定
                </div>
            </div>
        </div>
        <task-note v-if="page==='note'" :note-data="noteData" @update="onSaveNoteData" note-title="任務內容" note-placeholder="這個地點要做什麼事情呢？"/>
    </div>
</template>

<script>
    import Header from '../Header';
    import ATextare from '../AutoHeighTextarea';
    import { mapGetters, mapActions } from 'vuex';
    import SearchAddress from './SearchAddress';
    import PSwitch from '../Switch';
    import LimitSize from '../LimitSize';
    import PhotoUploader from "./PhotoUploader";
    import TaskNote from "./TaskNote";
    import TaskExpectedInput from "./TaskExpectedInput";

    export default {
        name: 'ElasticTask',
        components: {
            'p-header': Header,
            'a-textarea': ATextare,
            'search-address': SearchAddress,
            'p-switch': PSwitch,
            'limit-size': LimitSize,
            'photo-uploader': PhotoUploader,
            'task-note': TaskNote,
            'task-input': TaskExpectedInput,
        },
        props: {
            id: {
                default: undefined,
            },
            title: {
                default: '地址',
            }
        },
        data() {
            return {
                alias: '',
                city: '',
                district: '',
                road: '',
                additional: '',
                note: '',
                latitude: null,
                longitude: null,
                name: '',
                phone: '',
                searching: false,
                isSave: false,
                err: '',
                roadErr: '',
                isPrincipal: false,
                photos: [],
                page: 'task',
                expectedPrice: '',
            }
        },
        computed: {
            isFocus() {
                return ! this.road;
            },
            fullAddress() {
                return (this.city + this.district + this.road) || '';
            },
            noteData() {
                return {
                    note: this.note,
                    photos: this.photos,
                    expectedPrice: this.expectedPrice,
                };
            },
            ...mapGetters(['cartLocationById', 'user'])
        },
        methods: {
            showNote() {
                window.location.hash = 'note';
                this.page = 'note';
                this.err = '';
            },
            closeNote() {
                let hash = this.$route.hash.replace('#', '');

                if (hash === 'note') {
                    this.$router.back();
                }

                this.page = 'task';
            },
            onSaveNoteData(data) {
                if ('note' in data) {
                    this.err = '';
                    this.note = data['note'];
                }

                if ('photos' in data) {
                    this.photos = data['photos'];
                }

                if ('expectedPrice' in data) {
                    this.expectedPrice = data['expectedPrice'];
                }

                this.closeNote();
            },
            unclickPrincipal() {
                if (this.isPrincipal) {
                    this.$refs.principal.click();
                }
            },
            clickPrincipal() {
                if (this.isPrincipal ) {
                    this.name = this.user.name;
                    this.phone = this.user.phone;
                }
            },
            loadData() {
                let location = this.cartLocationById(this.id);

                this.alias = location.alias;
                this.city = location.city;
                this.district = location.district;
                this.road = location.road;
                this.additional = location.additional;
                this.note = location.note;
                this.latitude = location.latitude;
                this.longitude = location.longitude;
                this.name = location.name;
                this.phone = location.phone;
                this.isSave = location.isSave;
                this.photos = location.photos || [];
                this.expectedPrice = location.expectedPrice || '';
            },
            send() {
                this.err = '';
                this.roadErr = '';

                if (! this.note.length) {
                    this.err = '請填寫任務內容';
                    return;
                }

                if (! this.road) {
                    this.roadErr = '請確認地址是否正確';
                    return;
                }

                if (this.id != null) {
                    this.putCartLocation({
                        key: this.id,
                        location: {
                            alias: this.alias,
                            city: this.city,
                            district: this.district,
                            road: this.road,
                            additional: this.additional,
                            note: this.note,
                            latitude: this.latitude,
                            longitude: this.longitude,
                            isSave: this.isSave,
                            phone: this.phone,
                            name: this.name,
                            photos: this.photos,
                            expectedPrice: this.expectedPrice,
                        }
                    });

                    this.$router.go(-1);

                    return;
                }

                this.addCartLocation({
                    alias: this.alias,
                    city: this.city,
                    district: this.district,
                    road: this.road,
                    additional: this.additional,
                    note: this.note,
                    latitude: this.latitude,
                    longitude: this.longitude,
                    isSave: this.isSave,
                    phone: this.phone,
                    name: this.name,
                    photos: this.photos,
                    expectedPrice: this.expectedPrice,
                });

                this.$router.go(-1);
            },
            selectedPlace(place) {
                this.city = place.city;
                this.district = place.district;
                this.road = place.road;
                this.latitude = place.latitude;
                this.longitude = place.longitude;
                this.alias = place.alias;
            },
            ...mapActions(['putCartLocation', 'addCartLocation'])
        },
        created() {
            if (this.id != null) {
                this.loadData();
            }
        },
        watch: {
            '$route'() {
                let hash = this.$route.hash.replace('#', '');

                if (hash !== 'note' && hash !== 'photo') {
                    this.page = 'task'
                }
            }
        }
    };
</script>

<style lang="scss">
    .task {
        .item {
            textarea {
                min-height: 100px !important;
            }
        }
    }
</style>

<style lang="scss" scoped>
    .task {
        height: 100%;
    }

    .search {
        margin: 10px 15px;
    }

    .input-data {
        margin: 15px;

        .item {
            display: flex;
            flex-direction: column;
            align-items: flex-start;
            border-radius: 5px;
            background-color: rgba(255,255,255,1);
            box-shadow: 0 0 3px 0 rgba(51,153,51,0.5);
            margin-top: 5px;
            padding: 10px;
            position: relative;

            span {
                margin-bottom: 10px;
                color: rgba(0,0,0,1);
                font-family: "PingFang TC";
                font-size: 14px;
                line-height: 20px;
            }

            input {
                width: 100%;
                font-family: "PingFang TC";
                font-size: 14px;
                line-height: 20px;
                border: none;
            }

            .checkbox {
                position: absolute;
                right: 10px;
                top: 10px;
                color: #339933;
                font-size: 14px;
                letter-spacing: 0;
                line-height: 20px;
                cursor: pointer;
                user-select: none;
                display: flex;
                align-items: center;

                label {
                    display: flex;
                }

                input {
                    width: auto;
                    position: relative;
                }

                input:checked:before {
                    content: '';
                    position: absolute;
                    left: 1px;
                    top: 1px;
                    bottom: 1px;
                    right: 1px;
                    border-radius: inherit;
                    background-color: #339933;
                }

                input:checked:after {
                    content: '';
                    position: absolute;
                    bottom: 3px;
                    right: 7px;
                    width: 25%;
                    height: 50%;
                    border-bottom: 1px solid #fff;
                    border-right: 1px solid #fff;
                    transform: rotate(45deg);
                    transform-origin: 100% 100%;
                }
            }
        }
    }

    .detail {
        padding: 15px 25px;
        padding-bottom: 90px;

        .title {
            color: rgba(0, 0, 0, 1);
            font-family: "PingFang TC";
            font-size: 18px;
            font-weight: 500;
            line-height: 25px;
            text-align: left;
        }

        .item {
            display: flex;
            justify-content: space-between;
            color: rgba(74, 74, 74, 1);
            font-family: "PingFang TC";
            font-size: 14px;
            line-height: 20px;
            text-align: left;
            padding: 13px 0;
            border-bottom: solid 1px rgba(221, 221, 221, 1);

            &:nth-child(3) {
                border-bottom: none;
            }

            .span {
                width: 145px;
            }

            .input {
                display: flex;
                align-items: center;
                justify-content: flex-end;
                width: calc(100% - 145px);
                text-align: right;
                font-family: "PingFang TC";
                font-size: 14px;
                line-height: 20px;

                &.placeholder {
                    color: rgba(155, 155, 155, 1);
                }

                input {
                    text-align: right;
                    width: 100%;
                    border: none;
                    font-size: 14px;

                    &::placeholder {
                        color: rgba(155, 155, 155, 1);
                    }
                }
            }
        }
    }
    .button {
        height: 45px;
        border-radius: 35px;
        background-color: rgba(51,153,51,1);
        color: rgba(255,255,255,1);
        font-family: "PingFang TC";
        font-size: 14px;
        line-height: 20px;
        display: flex;
        align-items: center;
        justify-content: center;
        margin: 15px 0;
        position: absolute;
        width: calc(100% - 50px);
        bottom: 0;
    }

    .note {
        position: relative;

        .err-msg {
            position: absolute;
            color: rgba(244,67,54,1) !important;
            font-family: "PingFang TC";
            font-size: 12px;
            font-weight: 500;
            line-height: 17px;
            bottom: -8px !important;
            margin: 0 !important;
        }

        .line {
            border: solid 2px white;
            position: absolute;
            width: 103px;
            bottom: -2px;
            left: 6px;
        }

        &.err {
            border: 2px solid rgba(255,153,153,1);
            box-shadow: 0 2px 8px 0 rgba(255,153,153,0.35);
        }
    }
</style>
